// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7d8ade71","878":"13413c71"}[chunkId] + ".chunk.js";
};